import { render } from "./WidgetOrdersYearly.vue?vue&type=template&id=f30628fa&ts=true"
import script from "./WidgetOrdersYearly.vue?vue&type=script&lang=ts"
export * from "./WidgetOrdersYearly.vue?vue&type=script&lang=ts"

import "./WidgetOrdersYearly.vue?vue&type=style&index=0&id=f30628fa&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__